import React from "react";

import { joinClasses } from "./ResultsPrimitives.jsx";

export const RESULTS_HEADER_ROAD_PATH = "M 4 34 H 196";

export default function ResultsHeaderLoadingRail({
  alwaysVisible = false,
  className = "",
  scale = "default",
}) {
  return (
    <span
      className={joinClasses([
        "results-header-loading-rail h-8 w-[clamp(12rem,18vw,15rem)]",
        alwaysVisible ? "inline-flex" : "hidden min-[1101px]:inline-flex",
        scale === "large" ? "results-header-loading-rail--large" : "",
        className,
      ])}
      aria-hidden="true"
    >
      <span className="results-header-loading-rail__label">Chargement…</span>
      <svg
        className="results-header-loading-rail__svg"
        viewBox="0 0 200 40"
        preserveAspectRatio="xMidYMid meet"
        aria-hidden="true"
      >
        <path className="results-header-loading-rail__road" d={RESULTS_HEADER_ROAD_PATH} />
        <g className="results-header-loading-rail__waypoints">
          <circle cx="4" cy="34" r="2" />
          <circle cx="132" cy="34" r="2" />
          <circle cx="196" cy="34" r="2" />
        </g>
        <g className="results-header-loading-rail__truck">
          <g transform="translate(-54 -14.6) scale(0.6)">
            <path d="M 90 69 H 168 V 75 H 90 Z" />
            <rect x="90" y="43" width="76" height="26" />
            <path d="M 169 47 H 175 L 183 52 L 190 61 V 75 H 169 Z" />
            <path d="M 172 52 H 181 L 187 61 H 172 Z" />
            <path d="M 172 64 H 187 M 173 67 H 177 M 187 68 H 190" />
            {[101, 114, 127, 179].map((x) => (
              <g key={x} transform={`translate(${x} 75)`}>
                <g className="results-header-loading-rail__wheel">
                  <circle r="5" />
                  <path className="results-header-loading-rail__spokes" d="M 0 0 V -3.5 M 0 0 L 3 1.75 M 0 0 L -3 1.75" />
                </g>
              </g>
            ))}
          </g>
        </g>
      </svg>
    </span>
  );
}
